import imageCompression from 'browser-image-compression';

/**
 * Compress image for mobile upload
 * @param {File} file - Original image file
 * @returns {Promise<File>} Compressed image file
 */
export async function compressImage(file) {
  console.log('[Image Compression] Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');

  const options = {
    maxSizeMB: 2, // Max 2MB
    maxWidthOrHeight: 1920, // Max dimension for mobile
    useWebWorker: true,
    initialQuality: 0.92, // 92% quality (same as Sharp)
    fileType: 'image/jpeg' // Always output as JPEG for better compression
  };

  try {
    const compressedFile = await imageCompression(file, options);
    console.log('[Image Compression] Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
    console.log('[Image Compression] Compression ratio:', ((1 - compressedFile.size / file.size) * 100).toFixed(1), '%');
    return compressedFile;
  } catch (error) {
    console.error('[Image Compression] Error:', error);
    // If compression fails, return original file
    return file;
  }
}
